import Hero from "../components/Hero";
import EditorialMarquee from "../components/EditorialMarquee";
import Manifesto from "../components/Manifesto";
import Disciplines from "../components/Disciplines";
import FeaturedWork from "../components/FeaturedWork";
import Testimonials from "../components/Testimonials";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Disciplines />
      <FeaturedWork />
      <Testimonials />
    </main>
  );
}
